// Anteprima IA dentro il builder, per i soli super user.
//
// Serve a chi compone un set di sfondi: prima di copiare il brief vuole vedere
// come rende il tema, e vuole vederlo senza uscire dal modal ne' generare uno
// sfondo vero sul documento aperto.
//
// Modulo puro di proposito: chi chiama passa il generatore. Importare qui
// `generateAiBackground` tirerebbe dentro `~src/api` e quindi `window`, e questo
// file diventerebbe testabile solo sotto jsdom.

// Il manifesto del set e' 3424x2416: stesso rapporto (1,42), un ottavo scarso
// del lato. Multipli di 16 perche' gpt-image-2 li pretende. Il backend puo'
// normalizzare queste misure al minimo del modello, ma tenerle piccole evita
// di chiedere per errore una preview piu' grande se quel limite cambia.
export const PREVIEW_SIZES = {
  horizontal: { width: 432, height: 304 },
  vertical: { width: 304, height: 432 },
};

// L'anteprima serve a validare composizione e direzione artistica, non i
// dettagli finali: la qualita' minima riduce l'attesa rispetto alla resa del
// set, mentre JPEG alleggerisce anche il trasferimento dell'immagine temporanea.
export const PREVIEW_QUALITY = 'low';

export function previewSizeFor(orientation) {
  return PREVIEW_SIZES[orientation] || PREVIEW_SIZES.vertical;
}

/**
 * Genera l'anteprima in scala del prompt corrente.
 *
 * @param {Object} params
 * @param {string} params.prompt        prompt composto dal builder.
 * @param {('vertical'|'horizontal')} params.orientation
 * @param {Function} params.generate    di norma `generateAiBackground`.
 * @returns {Promise<{imageUrl: string, width: number, height: number}>}
 */
export async function generateBuilderPreview({
  prompt,
  orientation,
  generate,
} = {}) {
  if (typeof generate !== 'function') {
    throw new Error('Generatore dell’anteprima non fornito.');
  }
  if (typeof prompt !== 'string' || !prompt.trim()) {
    throw new Error('Prompt vuoto: non c’è niente da generare.');
  }

  const { width, height } = previewSizeFor(orientation);
  const risultato = await generate({
    prompt,
    width,
    height,
    quality: PREVIEW_QUALITY,
    outputFormat: 'jpeg',
  });

  const imageUrl = risultato && risultato.imageUrl;
  if (!imageUrl) {
    throw new Error('La generazione non ha restituito un’immagine.');
  }
  // L'URL finisce in un attributo src: uno schema diverso da http(s) non e' un
  // caso previsto e non deve arrivare al DOM.
  if (!/^https?:\/\//i.test(imageUrl)) {
    throw new Error('URL dell’anteprima non valido.');
  }

  return { imageUrl, width, height };
}
